import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axiosClient from '../api/AxiosConfig';

const UPLOAD_ENDPOINT = '/upload';

export const CKEditorComponent = ({ placeholder, value, onValueChange }) => {
  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append('image', file);
            axiosClient
              .post(UPLOAD_ENDPOINT, body)
              .then((res) => {
                resolve({
                  default: `${process.env.REACT_APP_IMAGE}${res.data.url}`,
                });
              })
              .catch((err) => console.log(err));
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  return (
    <div
      style={{
        padding: '15px 0',
      }}
    >
      <CKEditor
        config={{
          extraPlugins: [uploadPlugin],
          placeholder: placeholder || 'Nội dung bài viết',
        }}
        data={value}
        editor={ClassicEditor}
        onChange={(event, editor) => {
          const data = editor.getData();
          onValueChange(data);
        }}
      />
    </div>
  );
};

CKEditorComponent.prototype = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onValueChange: PropTypes.func,
};
